import { render } from "./bisePie.vue?vue&type=template&id=13fadcb3&scoped=true"
import script from "./bisePie.vue?vue&type=script&lang=js"
export * from "./bisePie.vue?vue&type=script&lang=js"

import "./bisePie.vue?vue&type=style&index=0&id=13fadcb3&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fadcb3"]])

export default __exports__